// 广告相关接口
import { api } from '@/utils/axios'

export interface HomeDialogBannerResponse {
    id: number, //主键
    title: string, //标题
    weight: number, //权重值
    productId: number, //产品id
    linkType: number, // 关联方式 1-关联产品 2-Banner链接
    bannerUrl: string, //广告图url
    bannerTargetUrl: string, //广告跳转目标url
    createdAt: string //创建时间
}

const bannerApi = {
  // 获取首页弹窗广告
  homeDialogBanner() {
    return api.get<HomeDialogBannerResponse[]>('/api/banner/homeDialogBanner', null, {
      // mock: true
    })
  },
  // 获取首页中插广告
  homeCarouselBanner() {
    return api.get<HomeDialogBannerResponse[]>('/api/banner/homeCarouselBanner', null, {
      // mock: true
    })
  },
}
export default bannerApi